export enum ROUTES {
  HOME = "/",
  LOGIN = "/login",
  REGISTER = "/register",
  NOT_FOUND = "/404",
  DASHBOARD = "/dashboard",
  MANAGE = "/dashboard/manage",
  PRODUCT = "/product/:slug",
  LOCATIONS = "/locations",
  PROFILE = "/profile",
  PROFILE_SETUP = "/profile/setup",
  RESET_PASSWORD = "/reset-password",
  RESET_REQUEST = "/reset-request",
  CHANGE_PASSWORD = "/change-password",
  CONFIRM_EMAIL = "/confirm-email",
  EMAIL_REDIRECT = "/email-confirmation",
  VERIFY_PHONE = "/verify-phone",
}

export enum ROUTES_GROUPE {
  DASHBOARD = "/dashboard",
}

export enum DASHBOARD_GROUPE {
  INDEX = "/",
  SERVICE = "/service",
}
